import React from 'react';

import * as RadixTabs from '@radix-ui/react-tabs';

import { classNames } from '../../utils/classNames';

export type Tab = {
  label: string;
  value: string;
  content: React.ReactNode;
  className?: string;
};

interface TabsProps {
  tabs: Tab[];
  defaultValue: string;
  label?: string;
  onChange?: (value: string) => void;
  tabListStyle?: string;
}
export function Tabs({
  defaultValue,
  label,
  tabs,
  onChange,
  tabListStyle,
}: TabsProps) {
  return (
    <RadixTabs.Root defaultValue={defaultValue} onValueChange={onChange}>
      <div className="border-b border-gray-200">
        <RadixTabs.List
          className={classNames(
            '-mb-px flex items-center space-x-8',
            tabListStyle
          )}
          aria-label={label}
        >
          {tabs.map((t) => (
            <RadixTabs.TabsTrigger
              key={t.value}
              value={t.value}
              className={classNames(
                'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'data-[state=active]:is-active data-[state=active]:border-primary-700 data-[state=active]:text-primary-700',
                'group flex cursor-pointer items-center space-x-2 whitespace-nowrap border-b-2 text-sm font-medium',
                t.className
              )}
            >
              <div className="px-1 py-4">{t.label}</div>
            </RadixTabs.TabsTrigger>
          ))}
        </RadixTabs.List>
      </div>

      {tabs.map((t) => (
        <RadixTabs.Content key={t.value} value={t.value} className="pt-2">
          {t.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
